import gql from 'graphql-tag';

import {
  FullDraftContentFragment,
  ThemeFragment,
  PublicUserFragment,
  AddressFragment,
  ProfileFragment,
  MetatagFragment,
  ObjectMetatagFragment,
} from '../fragments';

export default gql`
  ${PublicUserFragment}
  ${AddressFragment}
  ${ProfileFragment}
  ${MetatagFragment}
  ${ObjectMetatagFragment}
  ${ThemeFragment}
  ${FullDraftContentFragment}

  mutation UpdateDraft($draft: DraftContentInput!) {
    updateDraft(draft: $draft) {
      ...FullDraftContentFragment
    }
  }
`;
